






import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    isLoading: Boolean
  }
})
export default class Loader extends Vue {}
